export const routes = {
  login             : "auth/login",
  forgotPassword    : "auth/forgot-password",
  helpInfo          : "helps?help_id=login",
  getNewAccessToken : "auth/refresh-token",
  getUsers          : "users",
};
